import { AppTheme } from 'shared/constants/common';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';

export const useGetThemeColor = (): string => {
	const { resolvedColorScheme } = useResolvedColorScheme();
	const lightThemeColor = '#004d43';
	const darkThemeColor = '#202020';

	const themeColorMap: Record<string, string> = {
		[AppTheme.LIGHT]: lightThemeColor,
		[AppTheme.DARK]: darkThemeColor,
	};

	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return themeColorMap[resolvedColorScheme]!;
};
